import { emailValidator } from '@utils/validations/constants';

export const isEmailValidator = (values: string[]) => {
  const notEmailsList: number[] = [];

  values.forEach((value, index) => {
    if (!emailValidator.test(value) && value !== '') notEmailsList.push(index);
  });

  if (notEmailsList.length > 0) return notEmailsList;
  return true;
};
